import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
} from '@tanstack/react-query';
import { IFHError } from '../../../../apis/HttpBaseApiWrapper';
import { TPaginationParams } from '../../../../apis/__shared/shared.interfaces';
import { IRouteAssignmentsResponse } from 'src/apis/administration/administration.interfaces';
import { useRoutesAndSchedulesService } from 'src/apis/administration/useRoutesAndSchedulesService';

type TQueryError = IFHError<{ message: string }>;
export const getAssignmentListKey = 'get-assignment-list';

export const useAssignmentListHook = (
  params: TPaginationParams,
  options?: UseQueryOptions<IRouteAssignmentsResponse, TQueryError>
): UseQueryResult<IRouteAssignmentsResponse, TQueryError> => {
  const { getRouteAssignmentList } = useRoutesAndSchedulesService();

  return useQuery<IRouteAssignmentsResponse, TQueryError>({
    queryKey: [getAssignmentListKey, params],
    queryFn: () => getRouteAssignmentList(params),
    enabled: true,
    ...options,
  });
};
